import { todayStr } from './date';

export const STORE_KEY = "gym-app-v2";

export const defaultData = {
  sessions: {},
  settings: { compoundRest: 180, isolationRest: 90 },
  customProgram: {},
  bodyweights: [],
  dayStructure: null,
  onboardingComplete: false,
  startingWeights: {},
};

export function loadData() {
  try {
    const r = localStorage.getItem(STORE_KEY);
    if (!r) return { ...defaultData };
    const parsed = JSON.parse(r);
    return {
      ...defaultData,
      ...parsed,
      customProgram: parsed.customProgram || {},
      bodyweights: parsed.bodyweights || [],
      startingWeights: parsed.startingWeights || {},
    };
  } catch { return { ...defaultData }; }
}

export function saveData(d) {
  try { localStorage.setItem(STORE_KEY, JSON.stringify(d)); } catch(e) { console.error(e); }
}

export function exportData(data) {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `gym-backup-${todayStr()}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
